import * as React from 'react';

import BaseCampaignPage from './BaseCampaignPage';
import MessengerBrand from 'modules/messenger/components/MessengerBrand';

import { t } from 'utils/language';

import type { Params } from 'types';

type Props = {
  params: Params,
  location: {
    query: {
      id: string,
      subcampaignId: string,
      externalConversationId?: string
    }
  }
};

const CampaignMessagesPage = ({
  params,
  location: { query }
}: Props) => (
  <BaseCampaignPage
    params={params}
    documentTitle={t('messages_page')}
    pageType="messenger"
  >
    <MessengerBrand
      key={query.externalConversationId}
      subcampaignId={Number(query.subcampaignId)}
      campaignId={Number(params.id)}
      externalConversationId={query.externalConversationId}
    />
  </BaseCampaignPage>
);

export default CampaignMessagesPage;
